import React from "react";

/**
 * Bottom pagination bar shared across every dashboard table.
 * Auto-hides when there's only one page.
 * Consistent visual language with the Open Positions listing pagination.
 */
export default function TablePagination({ page, totalPages, rangeStart, rangeEnd, total, onPrev, onNext, testidPrefix = "table" }) {
  if (totalPages <= 1) return null;
  return (
    <div
      className="px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-navy/10 bg-slateBg/40"
      data-testid={`${testidPrefix}-pagination`}
    >
      <div className="text-[10px] uppercase tracking-[0.22em] text-navy/50">
        Showing <span className="text-navy font-semibold">{rangeStart}–{rangeEnd}</span> of {total}
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onPrev}
          disabled={page <= 1}
          className="inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-navy hover:text-gold px-3 py-1.5 border border-navy/20 hover:border-gold transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:text-navy disabled:hover:border-navy/20"
          data-testid={`${testidPrefix}-prev`}
        >
          ← Previous
        </button>
        <span className="text-[11px] uppercase tracking-[0.14em] text-navy/60 px-2" data-testid={`${testidPrefix}-page-indicator`}>
          Page <span className="text-navy font-semibold">{page}</span> / {totalPages}
        </span>
        <button
          type="button"
          onClick={onNext}
          disabled={page >= totalPages}
          className="inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-white bg-navy hover:bg-gold hover:text-navy px-3 py-1.5 border border-navy hover:border-gold transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-navy disabled:hover:text-white disabled:hover:border-navy"
          data-testid={`${testidPrefix}-next`}
        >
          Next →
        </button>
      </div>
    </div>
  );
}
